import { Container } from "../components/Container";
import { Products } from "../components/Products";
import { SectionTitle } from "../components/SectionTitle";



// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"


const Conditionning = () => {

  
  const { i18n } = useTranslation();



  let data = dataFR;
  if (i18n.language === "fr") {
    data = dataFR;
  } else if (i18n.language === "en") {
    data = dataEN;
  } else if (i18n.language ==="nl"){
    data = dataNL;
  }

  return (
    <Container>
      <SectionTitle
        preTitle={data.conditionning.preTitle}
        title={data.conditionning.title}
      ></SectionTitle>
      <Products data={data.blister} />
      <Products imgPos="right" data={data.pot} />
      <Products data={data.powder} />
    </Container>
  );
};

export default Conditionning;
